'use strict';

var $ = require('jquery');
var debounce = require('../utilities/debounce');

module.exports = function (options) {
    var context = options.context;

    function setup(jqSlideshow, speed) {
        jqSlideshow.slick({
            dots: true,
            arrows: true,
            appendArrows: $('[data-binding="hero-carousel-nav"]'),
            appendDots: $('[data-binding="hero-carousel-items"]'),
            prevArrow: '<button class="prev"></button>',
            nextArrow: '<button class="next"></button>',
            autoplay: true,
            autoplaySpeed: speed
        });
    }

    function mobileStyles(instanceSlide) {
        if (context.find('.hero-carousel__item-inner').css('position') === 'static') {
            if (context.find('[data-binding="hero-carousel-playpause"]').hasClass('pause')) {
                instanceSlide.slick('slickPause');
            }

            var imgHeight = context.find('.hero-carousel__item img').height();
            var carouselNavHeight = context.find('[data-binding="hero-carousel-nav"] .prev').height();
            var newCarouseNavTop = imgHeight - carouselNavHeight;

            context.find('[data-binding="hero-carousel-nav"] .prev, [data-binding="hero-carousel-nav"] .next').css({ 'top': newCarouseNavTop + 'px', 'transform': 'none' });
            context.find('.slick-dots').css({ 'top': imgHeight + 'px', 'bottom': 'auto' });
        } else {
            if (context.find('[data-binding="hero-carousel-playpause"]').hasClass('pause')) {
                instanceSlide.slick('slickPlay');
            }

            context.find('[data-binding="hero-carousel-nav"] .prev, [data-binding="hero-carousel-nav"] .next').css({ 'top': '50%', 'transform': 'translateY(-50%)' });
            context.find('.slick-dots').css({ 'top': 'auto', 'bottom': '0' });
        }
    }

    function videoSetup() {
        if (context.find('[data-binding="hero-carousel-video"]').length > 0 && context.find('.hero-carousel__item-inner').css('position') !== 'static') {
            // not mobile
            var videoElement = context.find('[data-binding="hero-carousel-video"]')[0];
            var videoFile = context.find('[data-binding="hero-carousel-video"] source').attr('data-src');

            videoElement.src = videoFile;
            videoElement.load();
            videoElement.oncanplay = function () {
                videoElement.play();
            };
        }
    }

    function init() {
        var cycleSpeed = context.attr('data-cycle-speed') * 1000;
        var instanceSlide = context.find('[data-binding="hero-carousel-items"]');

        setup(instanceSlide, cycleSpeed);

        context.find('[data-binding="hero-carousel-playpause"]').on('click', function () {
            if ($(this).hasClass('pause')) {
                instanceSlide.slick('slickPause');
                $(this).removeClass('pause').addClass('play');
            } else {
                instanceSlide.slick('slickPlay');
                $(this).removeClass('play').addClass('pause');
            }
        });

        videoSetup();
        mobileStyles(instanceSlide);

        $(window).on('resize', debounce(function () {
            mobileStyles(instanceSlide);
        }, 500));
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/hero-carousel.js
// module id = 503
// module chunks = 0